export default __webpack_public_path__ + "static/media/Achievements (1).9c069a39.jpg";